module.exports = __webpack_public_path__ + "static/img/hotmiddetail.63ffd85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hotpic/hotmiddetail.jpg
// module id = 6hfZ
// module chunks = 52